import React from 'react';

// Components
import {
  Modal,
  ModalHeader,
  ModalContent,
  Button,
  Cross,
  ModalDescription,
} from '@cashfree-intl/coherent';

// Types
import { ActionModalProps } from './types';

const ActionModal = ({
  title,
  children,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onClose,
  onConfirm,
  confirmButtonProps,
  cancelButtonProps,
  crossProps,
  ...props
}: ActionModalProps) => (
  <Modal $maxWidth="480" open data-testid="action-modal" {...props}>
    <ModalHeader>
      {title}
      <Cross onClick={onClose} {...crossProps} />
    </ModalHeader>
    <ModalContent className="action-modal-content">
      <ModalDescription>
        {children}
        <div className="mt-4 text-right">
          <Button
            link
            onClick={onClose}
            data-testid="cancel-button"
            {...cancelButtonProps}
          >
            {cancelText}
          </Button>
          <Button
            primary
            className="ml-2"
            onClick={onConfirm}
            data-testid="confirm-button"
            {...confirmButtonProps}
          >
            {confirmText}
          </Button>
        </div>
      </ModalDescription>
    </ModalContent>
  </Modal>
);

export default ActionModal;
